import type { DailyRevenueItem } from '../api/admin-api'

interface DailyRevenueTableProps {
  data: DailyRevenueItem[]
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr)
  const dayNames = ['일', '월', '화', '수', '목', '금', '토']
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}.${month}.${day} (${dayNames[date.getDay()]})`
}

function formatKrw(value: number): string {
  return value.toLocaleString('ko-KR')
}

export function DailyRevenueTable({ data }: DailyRevenueTableProps) {
  const sortedData = [...data].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  )

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              날짜
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              건수
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              원가
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              매출
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              차익
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {sortedData.map((item) => (
            <tr key={item.date} className="hover:bg-gray-50">
              <td className="px-6 py-3 text-sm text-gray-900">
                {formatDate(item.date)}
              </td>
              <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
                {item.generationCount.toLocaleString('ko-KR')}
              </td>
              <td className="px-6 py-3 text-sm text-amber-600 text-right tabular-nums">
                {formatKrw(item.costKrw)}
              </td>
              <td className="px-6 py-3 text-sm font-medium text-gray-900 text-right tabular-nums">
                {formatKrw(item.revenueKrw)}
              </td>
              <td className="px-6 py-3 text-sm text-blue-600 text-right tabular-nums">
                {formatKrw(item.profitKrw)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
